import { create } from 'zustand';
import { DeviceStoreType } from '../types/store/device.types';
import { DEFAULT_PROVIDER, getProvider } from '@/lib/callProviders/provider-registry';
import '@/lib/callProviders/twilio/adapter';

export const useDeviceStore = create<DeviceStoreType>((set) => ({
  device: null,
  initializeDevice: (token) => set({ device: getProvider(DEFAULT_PROVIDER)?.createDevice(token) ?? null }),
  updateDeviceToken: (device) => set({ device }),
  call: null,
  // acceptedTimestamp describes the call that is currently active, so swapping in a different
  // call (accepting a waiting call, promoting one after the active call ends) invalidates it.
  // Clearing it here keeps every switch path from inheriting the previous call's elapsed time.
  setCallState: (call) => set((state) => (state.call === call ? { call } : { call, acceptedTimestamp: '' })),
  acceptedTimestamp: '',
  updateAcceptedTimestamp: (acceptedTimestamp) => set({ acceptedTimestamp }),
  resetCall: () => set({ call: null, acceptedTimestamp: '' }),
}));
